import moment from 'moment';

export const yesterday = moment()
  .subtract(1, 'day')
  .startOf('day')
  .toDate();

export const initModelState = () => ({
  id: null,
  day: null,
  hour: null,
  place: null,
  comment: null,
});

export const modelToPayload = ({ id, day, hour, place, comment }) => ({
  id,
  date: modelDateToPayload(day, hour),
  place,
  comment,
});

export const payloadToModel = ({ id, date, place, comment }) => ({
  id,
  ...payloadDateToModel(date),
  place,
  comment,
});

export const modelDateToPayload = (day, hour) => {
  const _day = moment(day).format('YYYY-MM-DD');
  return moment(`${_day}/${hour}`, 'YYYY-MM-DD/HH:mm').toDate();
};

export const payloadDateToModel = (date) => {
  const _date = moment(date);
  return {
    day: _date.format('YYYY-MM-DD'),
    hour: _date.format('HH:mm'),
  };
};

export const sortByDate = (a, b) => moment(a).diff(b);

export const arrayContainsDate = (array, date) =>
  array.map((x) => new Date(x).getTime()).includes(new Date(date).getTime());
